import { Injectable, Inject } from '@angular/core';
import { ENV_CONFIG } from 'src/app/core/injection.token';
import { ApiService } from 'src/app/core/services/api.service';

@Injectable()
export class AddressAPIService {
  public constructor(
    @Inject(ApiService) private _apiService: ApiService,
    @Inject(ENV_CONFIG) private _envConfig: env.EnvData
  ) {}

  private readonly controller = 'address';

  public getCountries() {
    const request = 'getCountries';
    const url = this._apiService.buildUrl(this._envConfig.PORTAL_BACKEND_APISYNC_URL, this.controller, request);

    return this._apiService.get<app.models.DictionaryCountry[]>(url);
  }

  public getAddressInfo() {
    const request = 'getAddressInfo';
    const url = this._apiService.buildUrl(this._envConfig.PORTAL_BACKEND_APISYNC_URL, this.controller, request);

    return this._apiService.get<app.models.DynamicResponse<app.models.GetPartnerAddressModel[]>>(url);
  }

  public getEligibleCountries() {
    const request = 'getEligibleCountries';
    const url = this._apiService.buildUrl(this._envConfig.PORTAL_BACKEND_APISYNC_URL, this.controller, request);

    return this._apiService.get<app.models.DictionaryCountry[]>(url);
  }
}
